import { IconButton, Modal, PrimaryButton } from 'office-ui-fabric-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

const ConditionsPanel = ({ isOpen, onClose, onConfirm, content }) => {
  const { t: translator } = useTranslation();

  return (
    <div className="global-message">
      <Modal
        isOpen={isOpen}
        onDismiss={onClose}
        styles={modalStyles}
        isBlocking
      >
        <div className="modal-outer">
          <div className="modal-outer-header">
            <p>{translator('pages.hearingDetails.conditionsHeader')}</p>
            <IconButton
              onClick={onClose}
              iconProps={{ iconName: 'Cancel' }}
              styles={iconButtonStyles}
            />
          </div>
          <div className="modal-outer-content">
            <ReactMarkdown source={content} linkTarget={'_blank'} />
          </div>
          <div className="global-message-modal-button-bar">
            <PrimaryButton
              text={translator('global.yes')}
              onClick={onConfirm}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

const iconButtonStyles = {
  root: {
    color: '#605E5C',
  },
  rootHovered: {
    color: '#605E5C',
  },
};

const modalStyles = {
  main: {
    width: '60%',
    minWidth: '800px',
    maxWidth: '1200px',
  },
};

export { ConditionsPanel };
